<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.id }}
        <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit_V1" }}&gt;</span>
      </b-card-header>
      <b-card-body class="py-0">
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Payment Method" label-for="card" label-cols="12">
              <treeselect instanceId="card" type="number" v-model="item.payby" :clearable="false"
                :options="payby_options" :disabled="readonly"></treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Reason" label-for="reason" label-cols="12" size="sm">
              <treeselect instanceId="reason" type="number" v-model="item.reason" :clearable="false"
                :options="reason_options" :disabled="readonly"></treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Date" label-for="date" label-cols="12">
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-datepicker size="sm" v-model="item.date" :disabled="true" button-only label-help=""
                    hide-header locale="en-GB"></b-form-datepicker>
                </b-input-group-prepend>
                <b-form-input size="sm" id="date" v-model="item.date" :disabled="true" type="text"
                  placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" variant="outline-secondary" :disabled="true" @click="item.date = null">
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Date Travel')" :class="$helpers
    .requiredlabel(requirement, 'Date Travel')
    .slice(0, 1) == '*'
    ? 'text-danger'
    : ''
    " label-size="sm">
              <!-- <b-form-group label="Date Travel" label-for="datetravel" label-cols="12"> -->
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-datepicker size="sm" v-model="item.datetravel" :disabled="readonly" button-only label-help=""
                    hide-header locale="en-GB"></b-form-datepicker>
                </b-input-group-prepend>
                <b-form-input size="sm" id="date" v-model="item.datetravel" :disabled="readonly" type="text"
                  placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="item.datetravel = null">
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>


          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Supplier B/L')" :class="$helpers
    .requiredlabel(requirement, 'Supplier B/L')
    .slice(0, 1) == '*'
    ? 'text-danger'
    : ''
    " label-size="sm">
              <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="item.blac"
                :clearable="true" :async="true" :load-options="treeselect_loadBLAC" :show-count="true"
                :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" :disabled="readonly"
                search-nested>
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Payment Amount" label-for="amount" label-cols="12">
              <b-input-group>
                <b-form-input type="text" v-model="item.value" placeholder="Enter amount" size="sm" lazy-formatter
                  :formatter="nocomma" :disabled="readonly"></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" variant="outline-secondary" @click="item.value = ''" :disabled="readonly">
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Currency" label-for="currency" label-cols="12" label-size="sm">
              <treeselect instanceId="currency" type="number" v-model="item.currency" :clearable="false"
                :options="currency_options" :disabled="readonly"></treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Country" label-for="country" label-cols="12" label-size="sm">
              <treeselect instanceId="country" type="number" v-model="item.country" :clearable="false"
                :options="country_options" :disabled="readonly"></treeselect>
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col cols="9" sm="9">
            <b-form-group :label="$helpers.requiredlabel(
    requirement,
    'Details / MUST Inlcude ALL Conferma transaction IDs'
  )
    " :class="$helpers
    .requiredlabel(
      requirement,
      'Details / MUST Inlcude ALL Conferma transaction IDs'
    )
    .slice(0, 1) == '*'
    ? 'text-danger'
    : ''
    " label-for="data" label-cols="12">
              <b-form-textarea id="data" v-model="item.comments" placeholder="Details" rows="8" max-rows="8"
                class="smalltextarea" :disabled="readonly"></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="3" sm="3">
            <b-card class="py-0 h6 text-primary border-none">
              <div class="mb-2">
                <i class="fa fa-bullhorn fa-2x text-danger mr-2"></i>
                Wait, have you added?
              </div>
              <b-card-text class="h6">
                <b-row class="mt-1">
                  <b-col cols="auto">
                    <i class="fa fa-check-square-o text-danger mr-1"></i>
                  </b-col>
                  <b-col cols="auto"> Travel Dates </b-col>
                </b-row>
                <b-row class="mt-1">
                  <b-col cols="auto">
                    <i class="fa fa-check-square-o text-danger mr-1"></i>
                  </b-col>
                  <b-col cols="auto"> Routing </b-col>
                </b-row>
                <b-row class="mt-1">
                  <b-col cols="auto">
                    <i class="fa fa-check-square-o text-danger mr-1"></i>
                  </b-col>
                  <b-col cols="auto"> Airline </b-col>
                </b-row>
                <b-row class="mt-1">
                  <b-col cols="auto">
                    <i class="fa fa-check-square-o text-danger mr-1"></i>
                  </b-col>
                  <b-col cols="auto"> Traveller Name </b-col>
                </b-row>
                <b-row class="mt-1">
                  <b-col cols="auto">
                    <i class="fa fa-check-square-o text-danger mr-1"></i>
                  </b-col>
                  <b-col cols="auto"> Conferma transaction IDs </b-col>
                </b-row>
                <b-row class="float-right mt-3">
                  <b-col cols="auto"> Don't get unsubmitted!</b-col>
                  <b-col cols="auto">
                    <i class="fa fa-reply fa-2x text-danger mr-1"></i>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Client SL A/C')" :class="$helpers
    .requiredlabel(requirement, 'Client SL A/C')
    .slice(0, 1) == '*'
    ? 'text-danger'
    : ''
    " label-size="sm">
              <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="item.slac"
                :clearable="true" :async="true" :load-options="treeselect_loadSLAC" :show-count="true"
                :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" :disabled="readonly"
                search-nested>
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Price to Client £" label-for="charge" label-cols="12">
              <b-input-group>
                <b-form-input type="text" v-model="item.charge" placeholder="Enter price £" size="sm" lazy-formatter
                  :formatter="nocomma" :disabled="readonly"></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" variant="outline-secondary" @click="item.charge = ''" :disabled="readonly">
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group :label="$helpers.requiredlabel(requirement, 'Your Ref/PO')" :class="$helpers
    .requiredlabel(requirement, 'Your Ref/PO')
    .slice(0, 1) == '*'
    ? 'text-danger'
    : ''
    " label-for="yourref" label-cols="12">
              <b-input-group>
                <b-form-input type="text" v-model="item.yourref" placeholder="Enter your ref" size="sm"
                  :disabled="readonly"></b-form-input>

                <b-input-group-append>
                  <b-button size="sm" variant="outline-secondary" @click="item.yourref = ''" :disabled="readonly">
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group :label="$helpers.requiredlabel(requirement, 'Event')" :class="$helpers.requiredlabel(requirement, 'Event').slice(0, 1) == '*'
    ? 'text-danger'
    : ''
    " label-for="event" label-cols="12">
              <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..." v-model="item.event"
                :clearable="true" :async="true" :load-options="treeselect_loadEvent" :show-count="true"
                :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" :disabled="readonly"
                search-nested>
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group :label="$helpers.requiredlabel(requirement, 'Deployment Id')" :class="$helpers
    .requiredlabel(requirement, 'Deployment Id')
    .slice(0, 1) == '*'
    ? 'text-danger'
    : ''
    " label-for="deploymentid" label-cols="12">
              <b-input-group>
                <b-form-input type="text" v-model="item.deploymentid" placeholder="Enter deploymentid" size="sm"
                  :disabled="readonly"></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" variant="outline-secondary" @click="item.deploymentid = ''" :disabled="readonly">
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Booker Name" label-for="bookername" label-cols="12" size="sm">
              <treeselect instanceId="bookername" type="text" v-model="bookerinit" :clearable="false"
                :options="options_bookernames"></treeselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-2"><b-col><span class="text-danger small">* Required</span></b-col></b-row>
        <div v-if="user.permissions.includes('bookingforms.admin') &&
    idselected != null
    ">
          <div class="innerborder px-2 pt-1">
            <b-row>
              <b-col cols="12" sm="12">
                <b-form-group label="Message" label-for="data" label-cols="12">
                  <b-form-textarea id="data" v-model="item.message" placeholder="Message to Agent" rows="2"
                    class="smalltextarea"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Agent" label-for="agent" label-cols="12">
                  <b-input-group>
                    <b-form-input type="text" v-model="item.agent" placeholder="Enter agent" size="sm"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="item.agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="InvoiceNo" label-for="invoiceno" label-cols="12">
                  <b-input-group>
                    <b-form-input type="text" v-model="item.invoiceno" placeholder="Enter invoiceno"
                      size="sm"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="item.invoiceno = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Status" label-for="data" label-cols="12">
                  <b-form-radio-group id="higlight" v-model="item.status" :options="[
    { text: 'Submitted', value: 'submitted' },
    { text: 'Unsubmitted', value: 'unsubmitted' },
  ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline">
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Resend Mail ?" label-for="data" label-cols="12">
                  <b-form-radio-group id="mailagain" v-model="item.mailagain" :options="[
    { text: 'Yes', value: 'true' },
    { text: 'No', value: 'false' },
  ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline">
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-card-body>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left" cols="auto">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>

          <b-col class="text-right">
            <b-button class="mr-1" size="sm" variant="info" @click="submit()" squared v-if="submitvisible">
              <i class="fa fa-paper-plane"></i>
              Submit To Accounts
            </b-button>
            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button squared size="sm" variant="primary" v-if="savevisible" :disabled="savedisabled" @click="saveit()">
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "BookingFormEdit",
  computed: {
    submitvisible() {
      let result = false;
      if (this.item.status == "unsubmitted") {
        if (this.item.agent == this.user.initials) {
          result = true;
        }
      }
      if (this.user.permissions.includes("bookingforms.admin")) {
        result = true;
      }
      return result;
    },
    savevisible() {
      let result = false;
      if (this.item.status == "unsubmitted") {
        result = true;
      }
      if (this.user.permissions.includes("bookingforms.admin")) {
        result = true;
      }
      return result;
    },
    savedisabled() {
      let result = true;
      if (this.item.agent == this.user.initials) {
        result = false;
      }
      if (this.user.permissions.includes("bookingforms.admin")) {
        result = false;
      }
      return result;
    },
    readonly() {
      let result = true;
      if (this.item.status == "unsubmitted") {
        if (this.item.agent == this.user.initials) {
          result = false;
        }
      }
      if (this.user.permissions.includes("bookingforms.admin")) {
        result = false;
      }
      return result;
    },
  },
  watch: {
    "item.slac": {
      // deep: true,
      // immediate: true,
      async handler(newVal, oldVal) {
        console.log("watch:item.slac", newVal);
        let attributes = await this.$helpers.loadSLACAttributes(newVal);
        console.log(attributes);
        if (attributes.includes("/PO")) {
          this.$set(this.requirement, "yourref", "Your Ref/PO");
        } else {
          this.$delete(this.requirement, "yourref");
        }
        console.log(this.requirement);
        await this.load_bookerinitials();
      },
    },
    "item.payby": {
      async handler(newVal, oldVal) {
        console.log("watch:item.payby", newVal);
        if (newVal == "CONF") {
          this.$set(this.requirement, "deploymentid", "Deployment Id");
        } else {
          this.$delete(this.requirement, "deploymentid");
        }
        console.log(this.requirement);
        let payby = this.payby_options.find(o => o.id == newVal)
        console.log('newblac', payby)
        this.item.blac = null
        if (payby) {
          if (payby.blac) {
            if (!this.item.blac) {
              this.item.blac = payby.blac
            }
          }
        }
      },
    },
  },
  mounted() {
    this.item.agent = this.user.initials;
  },
  data() {
    return {
      busy: false,
      requirement: {
        blac: "Supplier B/L",
        comments: "Details / MUST Inlcude ALL Conferma transaction IDs",
        event: "Event",
        slac: "Client SL A/C",
        // deploymentid: "Deployment Id",
        datetravel: "Date Travel"
      },
      payby_options: [],
      reason_options: [],
      country_options: [],
      currency_options: [],
      options_bookernames: [],
      bookerinit: null,
      item: {
        id: null,
        date: this.$moment().format("YYYY-MM-DD"),
        datetravel: null,
        reason: "F",
        payby: "BANK",
        value: "0.00",
        deploymentid: null,
        currency: "GBP",
        country: "GB",
        comments: null,
        blac: null,
        slac: null,
        event: null,
        charge: null,
        invoiceno: null,
        yourref: null,
        agent: null,
        status: "unsubmitted",
        mailagain: "false",
      },
      options: {
        title: "Booking Form Edit",
        icon: "fa fa-tasks",
      },
    };
  },
  methods: {
    // nocomma(value) {
    //   return value.split(",").join("");
    // },
    async load_bookerinitials() {
      if (!this.item.slac) {
        this.options_bookernames = [];
        return;
      }

      let variables = {
        slac: this.item.slac,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_bookerinitials($slac: String) {
              setup_bookerinitials(slac: $slac) {
                id: initials
                label
              }
            }
          `,
          variables,
        });
        this.options_bookernames = response.data.setup_bookerinitials;
      } catch (error) {
        console.log(error);
      }
      if (this.item.yourref) {
        try {
          let yrparts = this.item.yourref.split("*");
          if (yrparts.length > 1) {
            this.bookerinit = yrparts[1];
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async loadDDL() {

      try {
        const response = await this.$apollo.query({
          query: gql`
            query bookingformspaytypes {
              bookingformspaytypes {
                id
                label
                blac
              }
            }
          `,
        });
        this.payby_options = response.data.bookingformspaytypes;
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query bookingformsreasontypes {
              bookingformsreasontypes {
                id
                label: name
              }
            }
          `,
        });
        this.reason_options = response.data.bookingformsreasontypes;
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_countries {
              setup_countries {
                id: code
                label
              }
            }
          `,
        });
        this.country_options = response.data.setup_countries;
        console.log(this.country_options);
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_currencies {
              setup_currencies {
                id:code
                label
              }
            }
          `,
        });
        this.currency_options = response.data.setup_currencies;
      } catch (error) {
        console.log(error);
      }
    },
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query bookingforms($id: String, $dateformat: String) {
              bookingforms(id: $id, dateformat: $dateformat) {
                id
                payby
                reason
                date
                datetravel
                blac
                value
                deploymentid
                currency
                country
                comments
                event
                slac
                charge
                invoiceno
                yourref
                agent
                status
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.bookingforms.length > 0) {
          this.item = response.data.bookingforms[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      let rows = [this.cleanit(this.item)];
      let requirements = "";
      for (var prop in this.requirement) {
        if (rows[0][prop] == null) {
          requirements += this.requirement[prop] + ",";
          break;
        }
      }
      if (requirements.length > 0) {
        this.message =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        this.busy = false;
        return;
      }

      if (this.item.slac == "BBC3" && this.item.yourref) {
        let yrparts = this.item.yourref.split("*");
        if (yrparts.length != 2) {
          this.message =
            "<span class='text-danger'>Your Ref/PO" +
            " needs a Booker Name (e.g. " +
            this.item.yourref +
            "*RE)</span>";
          if (!this.user.permissions.includes("bookingforms.admin")) {
            this.busy = false;
            return;
          }
        }
      }

      let variables = { rows };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation savebookingforms(
              $rows: [Bookingform_input]
              $dateformat: String
            ) {
              savebookingforms(rows: $rows, dateformat: $dateformat) {
                id
                payby
                reason
                date
                datetravel
                blac
                value
                deploymentid
                currency
                country
                comments
                event
                slac
                charge
                invoiceno
                yourref
                agent
                status
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";

        this.$emit("refresh");
        this.$emit("discard");
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async submit() {
      this.busy = true;

      let rows = [this.cleanit(this.item)];
      rows[0].status = "submitted";
      rows[0].mailagain = "true";

      let requirements = "";
      for (var prop in this.requirement) {
        if (rows[0][prop] == null) {
          requirements += this.requirement[prop] + ",";
          break;
        }
      }
      if (requirements.length > 0) {
        this.message =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        this.busy = false;
        return;
      }

      if (this.item.slac == "BBC3" && this.item.yourref) {
        let yrparts = this.item.yourref.split("*");
        if (yrparts.length != 2) {
          this.message =
            "<span class='text-danger'>Your Ref/PO" +
            " needs a Booker Name (e.g. " +
            this.item.yourref +
            "*RE)</span>";
          if (!this.user.permissions.includes("bookingforms.admin")) {
            this.busy = false;
            return;
          }
        }
      }

      let variables = { rows };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation savebookingforms(
              $rows: [Bookingform_input]
              $dateformat: String
            ) {
              savebookingforms(rows: $rows, dateformat: $dateformat) {
                id
                payby
                reason
                date
                datetravel
                blac
                value
                deploymentid
                currency
                country
                comments
                event
                slac
                charge
                invoiceno
                yourref
                agent
                status
              }
            }
          `,
          variables,
        });

        this.message = "<span class='text-primary'>Submitted it.</span>";

        // DONT FORGET THIS TO HIDE THE BUTTON
        this.item.status = "submitted";

        this.$emit("refresh");
        this.$emit("discard");
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
      this.busy = false;
    },

  },
};
</script>

<style></style>